import React from 'react';
import { Switch, Route } from 'react-router';
import { OrderSummary } from './components/pages/OrderSummary';
import OrderDetails from './components/pages/OrderDetails';
import ErrorPage from './components/pages/ErrorPage';

export default () => (
  <Switch>
    <Route path="/" exact component={OrderSummary} />
    <Route path="/order-details/:transactionId" component={OrderDetails} />
    <Route path="/error-screen" component={ErrorPage} />
  </Switch>
);



// WEBPACK FOOTER //
// src/routes.jsx